import { memo, useMemo } from "react";

import { IconCore } from "@icon";
import { getThemeColor } from "@theme";
import { fontSizeToRem } from "@utils/fontSizeMapper";

import type { IIconProps } from "@atoms/icon/types";

export const Icon = memo(function Icon({
  name,
  fontSize,
  customSize,
  color,
  className,
}: IIconProps) {
  const size = useMemo(
    () => (fontSize ? `${fontSizeToRem(fontSize)}rem` : customSize),
    [customSize, fontSize],
  );

  return (
    <IconCore
      className={className}
      iconName={name}
      color={
        color ? getThemeColor(color || "text-sub-600").colorValue : undefined
      }
      size={size}
    />
  );
});
